import { Component, Vue, Watch } from 'vue-property-decorator'
import './navigation.scss'

@Component({
  template: require('./navigation.pug'),
  props: [
    'userInfo',
    'canAccessAdmin',
    'isFmoduleEval360Allowed',
    'isFmoduleAnnouncementAllowed',
    'isFmoduleScheduledJobsAllowed',
    'isFmoduleDemoCompanyAllowed',
    'isFmoduleUserStatisticsAllowed',
    'isFmoduleTotalStatisticsAllowed',
    'isFmoduleOkrAllowed',
    'isFmoduleAccessRequestAllowed'
  ]
})
export class NavigationComponent extends Vue {
  constructor() {
    super()
  }
  canAccessAdmin
  userInfo
  isFmoduleEval360Allowed
  isFmoduleAnnouncementAllowed
  isFmoduleScheduledJobsAllowed
  isFmoduleDemoCompanyAllowed
  isFmoduleUserStatisticsAllowed
  isFmoduleTotalStatisticsAllowed
  isFmoduleOkrAllowed
  isFmoduleAccessRequestAllowed

  toggleHamburger(): void {
    const burger = document.querySelector('.burger')
    const nav = document.querySelector('#main-navbar')

    burger.classList.toggle('is-active')
    nav.classList.toggle('is-active')
  }

  // Mobilde bir menüden sayfaya gidildiğinde hamburger menüsünü kapat
  @Watch('$route')
  closeHamburger(): void {
    const burger = document.querySelector('.burger')
    const nav = document.querySelector('#main-navbar')

    burger?.classList.remove('is-active')
    nav?.classList.remove('is-active')
  }
}
